<template>
    <div class="team">
        <div class="member">
            <div class="member__image">
                <img src="../assets/profile-henry.png" alt />
            </div>
            <div class="member__profile">
                <div class="member__name">Mr Henry Yates</div>
                <div class="member__title">Development Chairperson</div>
                <div class="member__phone">Contact: 087 262 7342</div>
                <div class="member__email">
                    <a href="mailto:henryyates@devfoundation.ie">henryyates@devfoundation.ie</a>
                </div>
            </div>
        </div>

        <div class="member">
            <div class="member__image">
                <img src="../assets/profile-simon.png" alt />
            </div>
            <div class="member__profile">
                <div class="member__name">Mr Simon Thompson</div>
                <div class="member__title">Principal</div>
                <div class="member__phone">Contact: 056 776 1544</div>
                <div class="member__email">
                    <a
                        href="mailto:simonthompson@kilkennycollege.ie"
                    >simonthompson@kilkennycollege.ie</a>
                </div>
            </div>
        </div>

        <div class="member">
            <div class="member__image">
                <img src="../assets/profile-peter.png" alt />
            </div>
            <div class="member__profile">
                <div class="member__name">Mr Peter Dukelow</div>
                <div class="member__title">Development Foundation Member</div>
                <div class="member__phone">Contact: 086 368 5426</div>
                <div class="member__email">
                    <a href="mailto:peterdukelow@devfoundation.ie">peterdukelow@devfoundation.ie</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.team {
    @include gridBlock();
    grid-template-columns: repeat(3, 1fr);
    justify-content: space-between;
    margin: 4rem auto;

    @include tablet {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        margin-bottom: 0;
    }

    .member {
        text-align: center;
        font-size: 0.875rem;

        @include tablet-and-mobile {
            margin-bottom: 3rem;
        }

        @include tablet {
            flex-basis: 50%;
        }

        a {
            color: var(--primary_font_colour);
        }

        &__phone {
            margin-top: 1rem;
        }

        &__name {
            font-size: 1rem;
            margin-top: 0.5rem;
        }
    }
}
</style>
